import React from "react";
import styled from "styled-components";
import { IoIosWarning } from "react-icons/io";
import { FaInfoCircle } from "react-icons/fa";
import { VscError } from "react-icons/vsc";


const Card = styled.div`
  background-color: ${(props) => {
    if (props.$variant === "error") return "#FFF5F5";
    if (props.$variant === "warning") return "#FFF8F1";
    if (props.$variant === "info") return "#EBF8FF";
    return "#FFF8F1";
  }};
  border: 2px solid
    ${(props) => {
      if (props.$variant === "error") return "#FEB2B2";
      if (props.$variant === "warning") return "#FED7AA";
      if (props.$variant === "info") return "#90CDF4";
      return "#FED7AA";
    }};
  border-radius: var(--zyvgo-radius-md, 8px);
  padding: 20px 24px;
  margin: 24px 0;
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

const IconContainer = styled.div`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: ${(props) => {
    if (props.$variant === "error") return "#FEB2B2";
    if (props.$variant === "warning") return "#FED7AA";
    if (props.$variant === "info") return "#90CDF4";
    return "#FED7AA";
  }};
`;

const Content = styled.div`
  flex: 1;
`;

const Title = styled.h4`
  margin: 0 0 8px 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--zyvgo-text-primary, #222222);
`;

const Message = styled.p`
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: var(--zyvgo-text-secondary, #666666);
`;

const ActionButton = styled.button`
  margin-top: 0.75rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.5rem;
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  cursor: pointer;
`;

const ErrorCard = ({
  title,
  message,
  variant = "warning", // 'error', 'warning', 'info'
  icon,
  action = null, // { label, onClick } -- one deterministic next step
}) => {
  const getDefaultIcon = () => {
    if (icon) return icon;
    if (variant === "error") return <VscError />;
    if (variant === "warning") return <IoIosWarning />;
    if (variant === "info") return <FaInfoCircle />;
    return <FaInfoCircle />;
  };

  return (
    <Card $variant={variant}>
      <IconContainer $variant={variant}>{getDefaultIcon()}</IconContainer>
      <Content>
        {title && <Title>{title}</Title>}
        <Message>{message}</Message>
        {action?.label && (
          <ActionButton type="button" onClick={action.onClick}>
            {action.label}
          </ActionButton>
        )}
      </Content>
    </Card>
  );
};

export default ErrorCard;
